import { render, staticRenderFns } from "./banner1.vue?vue&type=template&id=dc5da57e&scoped=true&"
import script from "./banner1.vue?vue&type=script&lang=js&"
export * from "./banner1.vue?vue&type=script&lang=js&"
import style0 from "./banner1.vue?vue&type=style&index=0&id=dc5da57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5da57e",
  null
  
)

export default component.exports